import $ from "jquery";

function checkColour($this) {
    if($this.hasClass('green')) {
        return '#006E63';
    }
    if($this.hasClass('grey')) {
        return '#9FA9B2';
    }
    return '#B5DCD6'
}
$('.nav-desktop-menu .underlinehover a').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="menuunderline"></span>');
});


$('.heading--underline-a').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="6" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});


$('.heading--underline-b').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="6" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.heading--underline-c').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="6" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.heading--underline-d').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="6" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.heading--underline-e').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="6" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.heading--underline-f').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="6" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.heading--underline-g').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="6" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.heading--underline-h').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="6" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.heading--underline-i').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="6" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.heading--underline-ext').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="6" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});


$('.link--underline-a').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="5" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.link--underline-b').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="5" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.link--underline-c').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="5" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.link--underline-d').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="5" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.link--underline-e').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="5" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.link--underline-f').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="5" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.link--underline-g').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="5" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.link--underline-h').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="5" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$('.link--underline-i').each(function(){
    var colour = checkColour($(this));
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="5" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});

$(".heading--underline-wrap").each(function(){
    var $this = $(this);
    var words = $(this).text().split(" ");

    words = $.grep(words, function(value) {
        return value != '';
    });

    words = $.grep(words, function(value) {
        return value != '\n';
    });

    console.log(words);
    $this.empty();
    $.each(words, function(i, v) {
      $this.append($("<span>").text(v));
    });
    // console.log(words);
});

$(".heading--underline-wrap span").each(function(){
    var colour = checkColour($(this).parent());
    // var colour = '#B5DCD6';
    $(this).append('<span class="underline"><svg preserveAspectRatio="none" viewBox="0 0 56 6" xmlns="http://www.w3.org/2000/svg"><path style="vector-effect: non-scaling-stroke;" stroke="' + colour + '" stroke-width="5" d="M3 3h50" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg></span>');
});